import { render, staticRenderFns } from "./ListaChats.vue?vue&type=template&id=584ca43c"
import script from "./ListaChats.vue?vue&type=script&lang=js"
export * from "./ListaChats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports